module.exports = __webpack_public_path__ + "static/media/Knobs_Time_Right_Down.fde04eef.png";